import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, MapPin, Phone, Mail, Facebook, Instagram, Youtube, Linkedin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo y descripción */}
          <div>
            <div className="mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_mit-formacion/artifacts/exrbgv3z_Logo%20MIT%20V3.png" 
                alt="MIT Instituto de Formación Digital" 
                className="h-14 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-sm text-gray-400 mb-6">
              Formación técnica profesional de calidad con títulos a nombre de la nación. Construyendo el futuro de los profesionales del Perú.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-mit-blue transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-mit-blue transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-mit-blue transition-colors">
                <Youtube className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-mit-blue transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Enlaces rápidos */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Enlaces Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/carreras" className="text-sm hover:text-mit-red transition-colors">
                  Carreras Técnicas
                </Link>
              </li>
              <li>
                <Link to="/convalidacion" className="text-sm hover:text-mit-red transition-colors">
                  Convalidación
                </Link>
              </li>
              <li>
                <Link to="/por-que-mit" className="text-sm hover:text-mit-red transition-colors">
                  ¿Por qué estudiar aquí?
                </Link>
              </li>
              <li>
                <Link to="/admision" className="text-sm hover:text-mit-red transition-colors">
                  Admisión y Titulación
                </Link>
              </li>
            </ul>
          </div>

          {/* Carreras destacadas */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Carreras Destacadas</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/carreras/administracion" className="text-sm hover:text-mit-red transition-colors">
                  Administración de Empresas
                </Link>
              </li>
              <li>
                <Link to="/carreras/contabilidad" className="text-sm hover:text-mit-red transition-colors">
                  Contabilidad
                </Link>
              </li>
              <li>
                <Link to="/carreras/mercadotecnia" className="text-sm hover:text-mit-red transition-colors">
                  Mercadotecnia
                </Link>
              </li>
              <li>
                <Link to="/carreras/computacion" className="text-sm hover:text-mit-red transition-colors">
                  Computación e Informática
                </Link>
              </li>
              <li>
                <Link to="/carreras/enfermeria" className="text-sm hover:text-mit-red transition-colors">
                  Enfermería Técnica
                </Link>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Contacto</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-mit-red flex-shrink-0 mt-0.5" />
                <span className="text-sm">
                  Av. Goyeneche 101, Arequipa 04001
                </span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-mit-red flex-shrink-0 mt-0.5" />
                <a href="tel:+51944748443" className="text-sm hover:text-mit-red transition-colors">
                  +51 944 748 443
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-mit-red flex-shrink-0 mt-0.5" />
                <span className="text-sm">
                  admision@institutomit.edu.pe
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Línea divisoria y copyright */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-500">
              © {currentYear} MIT Instituto de Formación Digital. Todos los derechos reservados.
            </p>
            <div className="flex gap-6">
              <Link to="/privacidad" className="text-sm text-gray-500 hover:text-mit-red transition-colors">
                Política de Privacidad
              </Link>
              <Link to="/terminos" className="text-sm text-gray-500 hover:text-mit-red transition-colors">
                Términos y Condiciones
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};